import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import hljs from 'highlight.js';
import 'highlight.js/styles/github-dark.css';

// Configure marked with highlight.js
marked.setOptions({
  highlight(code, lang){
    if (lang && hljs.getLanguage(lang)) {
      return hljs.highlight(code, { language: lang }).value;
    }
    return hljs.highlightAuto(code).value;
  },
  breaks: true
});

function MarkdownRender({ content }) {
  const html = useMemo(() => {
    if(!content) return '';
    // Basic safety: strip <script> and sanitize
    const raw = marked.parse(content);
    return DOMPurify.sanitize(raw, { USE_PROFILES: { html: true } });
  }, [content]);

  return (
    <div className="markdown" dangerouslySetInnerHTML={{ __html: html }} />
  );
}

export default MarkdownRender;
